import React, { useEffect, useState } from "react";
import { db, auth } from "../../firebase";
import { Drawer } from "@material-ui/core";
import { Link, Redirect, useHistory } from "react-router-dom";
import NavFront from "./Front/NavFront";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import firebase from "firebase";
import Search from "./Front/Search";
import Toolbar from "@material-ui/core/Toolbar";
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Grid from '@material-ui/core/Grid';
import { useAlert } from 'react-alert'


// import {Container,Row,Col} from 'react-bootstrap';

import TextField from "@material-ui/core/TextField";
import { lightBlue } from "@material-ui/core/colors";
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    fontFamily: "Rubik"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    fontSize: "15px",
    boxShadow: "0px 1px 4px rgb(0 0 0 / 20%)",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    '@media (max-width: 1020px)': {
      width: `calc(${drawerWidth}px - 40px)`,
    },
    '@media (max-width: 680px)': {
      width: `calc(${drawerWidth}px - 90px)`,
    },
    '@media (max-width: 430px)': {
      width: `calc(${drawerWidth}px - 130px)`,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#DBDBDB",
    overflow: "hidden",
    paddingTop: "100px",
    '@media (max-width: 1020px)': {
      width: `calc(${drawerWidth}px - 40px)`,
    },
    '@media (max-width: 680px)': {
      width: `calc(${drawerWidth}px - 90px)`,
    },
    '@media (max-width: 430px)': {
      width: `calc(${drawerWidth}px - 130px)`,
    },
  },
  elevation4: {
    boxShadow: 0,
  },
  drawerContainer: {
    overflow: "auto",
  },
  content: {
    flexGrow: 1,
    margin: "150px 50px 0",
    '@media (max-width: 1020px)': {
      margin: "150px 30px 0",
    },
    '@media (max-width: 680px)': {
      margin: "150px 20px 0",
    },
    '@media (max-width: 430px)': {
      margin: "150px 10px 0",
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
  },
  link: {
    display: "block",
    textDecoration: "none",
    color: "black",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "18px",
    padding: "10px 0 10px 2vw",
    marginTop: "35px",
    cursor: "pointer",
    '&:hover': {
      cursor: "pointer",
      textDecoration: "none",
      color: "unset"
    },
    '@media (max-width: 1020px)': {
      fontSize: "16px",
    },
    '@media (max-width: 680px)': {
      fontSize: "14px",
    },
    '@media (max-width: 430px)': {
      fontSize: "12px",
    },
  },
  heading: {
    padding: "10px 0 10px 2vw",
    '@media (max-width: 1020px)': {
      fontSize: "22px",
    },
    '@media (max-width: 680px)': {
      fontSize: "20px",
    },
    '@media (max-width: 430px)': {
      fontSize: "18px",
    },
  },

  title: {
    '@media (max-width: 1020px)': {
      fontSize: "26px",
    },
    '@media (max-width: 680px)': {
      fontSize: "24px",
    },
    '@media (max-width: 430px)': {
      fontSize: "22px",
    },
  },
  grid: {
    // margin: "10px 0",
    marginTop: "50px",
    marginBottom: "50px",
    textAlign: "center",
    '@media (max-width: 950px)': {
      marginTop: "30px",
      marginBottom: "30px",
      textAlign: "left",
    },
  },
  input: {
    color: "black",
    width: "210px",
    padding: "1.5px",
    '@media (max-width: 950px)': {
      width: "280px",
    },
    '@media (max-width: 480px)': {
      width: "220px",
    },
  },
  label: {
    '@media (max-width: 1020px)': {
      fontSize: "18px",
    },
    '@media (max-width: 680px)': {
      fontSize: "16px",
    },
    '@media (max-width: 430px)': {
      fontSize: "14px",
    },
  }
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    width: "100px",
    height: "40px",
    border: "none",
    color: "white",
    borderRadius: "18px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "normal",
    // font-size: 19px,
    textAlign: "center",
    // '&:hover': {
    //   background: "#5db0d8",
    // },
  },
}))(Button);

const SettingAcc = (props) => {
  const classes = useStyles();
  const history = useHistory();
  if (localStorage.getItem("allowed") === "0") {
    window.location.href = "/home";
  }
  // const search = props.location.search; // returns the URL query String
  // const params = new URLSearchParams(search);
  // const IdFromURL = params.get('from');
  // console.log(IdFromURL, 'fromee');
  // console.log(props.location.state.var);
  const logOut = () => {
    auth.signOut();
    localStorage.removeItem("user");
    history.push("/home");
    localStorage.setItem("allowed", "0");
    localStorage.setItem("signup", "0");
  };


  const [open, setOpen] = React.useState(false);
  const [openDeactivate, setOpenDeactivate] = React.useState(false);
  const [name, setname] = useState();
  const [email, setemail] = useState();
  const [isnamechange, setisnamechange] = useState(true);
  const [ispasschange, setispasschange] = useState(true);
  const [currentPassword, setcurrentPassword] = useState();
  const [newPassword, setnewPassword] = useState();
  const [searchtype, setsearchtype] = useState([]);
  const [navClick, setnavClick] = useState(false);
  const [searchtext, setsearchtext] = useState("");
  const [allposts, setallposts] = useState([]);
  const [exacttitle, setexacttitle] = useState("");
  const [searchtitle, setsearchtitle] = useState([]);
  const [searchClicked, setsearchClicked] = useState(false);
  const uid = JSON.parse(localStorage.getItem("user"))["uid"];

  // const [deactivateClicked, setdeactivateClicked] = useState(false);


  const alert = useAlert()
  const deleteUser = async () => {
    // setdeactivateClicked(!deactivateClicked);
    // console.log("inside delete user  " + deactivateClicked);

    // const res = await handleDClick;
    const res = await db.collection('users').doc(uid).delete();

    const postdata = await db.collection("posts").where("postedBy", "==", uid).get();
    await postdata.docs.forEach(item => {
      db.collection("posts").doc(item.id).delete();
      // console.log(db.collection("posts").doc(item.id));
    })

    // console.log(res);
    auth.signOut();
    localStorage.removeItem("user");
    history.push("/");
    // localStorage.removeItem(uid);
    // localStorage.setItem("allowed", "0");
    // localStorage.setItem("signup", "0");
    alert.success(<div style={{ textTransform: 'none', fontSize: "13px", textAlign: "center", padding: "5px" }}>User Deleted Successfully!</div>)

  };
  // console.log("outside delete user before fetchinfo " + deactivateClicked);
  // const fetchinfo = async () => {
  //   if (!deactivateClicked) {
  //     var docRef = db.collection("users").doc(uid);
  //     const data2 = await docRef.onSnapshot((querySnapshot) => {
  //       setname(querySnapshot.data().name);
  //       setemail(querySnapshot.data().email);
  //     });
  //   }
  // };
  // console.log(uid);


  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenDeactivate = () => {
    setOpenDeactivate(true);
  };
  const handleCloseDeactivate = () => {
    setOpenDeactivate(false);
  };


  // useEffect(() => {
  //   fetchinfo();
  // }, []);


  useEffect(() => {
    async function fetchdata() {
      const user1 = JSON.parse(localStorage.getItem("user"));
      console.log(user1);
      if (user1) {
        setname(user1.name);
        setemail(user1.email);
      } else {
        //   if (!history.location.pathname.startsWith("/signup") && !state.uid) {
        //       history.push("/signin");
        // }
      }
    }
    fetchdata();
  }, []);


  const changename = () => {
    setisnamechange(false);
  };
  const savename = async () => {
    await db.collection("users").doc(uid).update({ name: name });
    const data = await db.collection("posts").where("postedBy", "==", uid).get();
    await data.docs.forEach(item => {
      db.collection("posts").doc(item.id).update({ name: name });
    })
    setisnamechange(true);
    // localStorage.setItem("user")
    let loggedInUser = JSON.parse(localStorage.getItem('user'));
    loggedInUser.name = name;
    localStorage.setItem('user', JSON.stringify(loggedInUser));
  };

  const changePassword = () => {
    var user = auth.currentUser;
    // var cred = auth.EmailAuthProvider.credential(
    //     email, currentPassword);

    var cred = firebase.auth.EmailAuthProvider.credential(
      email,
      currentPassword
    );
    user
      .reauthenticateWithCredential(cred)
      .then(() => {
        console.log("reauthenticated");
        user
          .updatePassword(newPassword)
          .then(() => {
            alert("Password updated!");
            setcurrentPassword(null);
            setnewPassword(null);
          })
          .catch((error) => {
            alert(error);
          });
      })
      .catch((error) => {
        alert(error);
      });

    setispasschange(true);
  };

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar style={{ boxShadow: 'none' }} position="fixed" className={classes.appBar}>
          <NavFront
            setnavClick={setnavClick}
            setsearchClicked={setsearchClicked}
            setexacttitle={setexacttitle}
            searchtitle={searchtitle}
            setsearchtitle={setsearchtitle}
            searchtext={searchtext}
            setsearchtext={setsearchtext}
            setsearchtype={setsearchtype}
          />
          <div>
            {!searchClicked && searchtext !== "" ? (
              <Search
                exacttitle={exacttitle}
                searchtitle={searchtitle}
                setsearchClicked={setsearchClicked}
                searchtype={searchtype}
                searchtext={searchtext}
              />

            ) : null}
          </div>
        </AppBar>

        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerContainer}>
            <h4 className={classes.heading}>Settings</h4>
            <Divider />
            <List>
              {/* {['Account', 'Notification', 'Feedback', 'Log Out'].map((text, index) => (
            <ListItem button key={text}>
             
              <ListItemText primary={text} style={{fontWeiight: '700'}}/>
            </ListItem>
          ))} */}
              <Link className={classes.link}
                to="/settings"
                style={{
                  backgroundColor: "#807e7e",
                  color: "white",
                }}
              >
                Account
              </Link>

              <Link className={classes.link} to="/notification">
                Notifications
              </Link>

              <Link className={classes.link} to="/feedback">
                Feedback
              </Link>

              <Link className={classes.link}
                onClick={handleOpen}
              >
                Log Out
              </Link>

              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <h5 id="spring-modal-title">Are you sure you want to Log Out?</h5>
                    <div className={classes.root} style={{ justifyContent: "space-evenly", marginTop: "20px" }}>
                      <ColorButton variant="contained" style={{ background: "#5db0d8" }} onClick={() => { logOut() }}>
                        Yes
                      </ColorButton>
                      <ColorButton variant="contained" color="secondary" onClick={() => { handleClose() }}>No</ColorButton>
                    </div>
                  </div>
                </Fade>
              </Modal>

            </List>
          </div>
        </Drawer>

        <main className={classes.content}>
          {/* <div className={classes.toolbar} /> */}

          <h3 className={classes.title}>General</h3>

          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} md={4} className={classes.gridItem}>
              <h5 className={classes.label}>
                Email ID
              </h5>
              <input
                value={email}
                type="email"
                autoComplete="off"
                style={{
                  color: "#000000",
                }}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={4} className={classes.gridItem}>
              <h5 className={classes.label}>
                Username
              </h5>
              <input
                type="text"
                autoComplete="off"
                value={name}
                className={classes.input}
                disabled={isnamechange}
                onChange={(e) => setname(e.target.value)}
              />
              {isnamechange ? (
                <Change onClick={changename}>Change</Change>
              ) : (
                <Change onClick={savename}>Save</Change>
              )}
            </Grid>
            <Grid item xs={12} md={4} className={classes.gridItem}>
              <h5 className={classes.label}>
                New Password
              </h5>
              <input
                type="password"
                autoComplete="off"
                className={classes.input}
                onChange={(e) => setnewPassword(e.target.value)}
              />
              {ispasschange ? (
                <Change onClick={() => setispasschange(false)}>Change</Change>
              ) : (
                <div>
                  {" "}
                  <h5 className={classes.label} style={{ marginTop: "20px" }}>
                    Old Password
                  </h5>
                  <input
                    type="password"
                    onChange={(e) => setcurrentPassword(e.target.value)}
                    className={classes.input}
                  />
                  <Change onClick={changePassword}>Save</Change>
                </div>
              )}
            </Grid>

          </Grid >

          {/* <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <h5>
                  Email
                </h5>
                <input
                  value={email}
                  type="email"
                  autoComplete="off"
                  style={{
                    width: "15vw",
                    paddingLeft: "0.1vw",
                    color: "#000000",
                  }}
                  disabled={true}
                />
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <h5 style={{ margin: "1%", marginLeft: "5vw" }} type="text">
                  <b>Username</b>
                </h5>
                <input
                  type="text"
                  autoComplete="off"
                  value={name}
                  style={{
                    marginLeft: "1.3vw",
                    marginTop: "0.5vh",
                    width: "15vw",
                    paddingLeft: "0.1vw",
                  }}
                  disabled={isnamechange}
                  onChange={(e) => setname(e.target.value)}
                />
                {isnamechange ? (
                  <Change onClick={changename}>Change</Change>
                ) : (
                  <Change onClick={savename}>Save</Change>
                )}
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <h5 style={{ margin: "1%", marginLeft: "5vw" }}>
                  <b>New Password</b>
                </h5>
                <input
                  type="password"
                  autoComplete="off"
                  style={{
                    marginLeft: "1.3vw",
                    marginTop: "0.5vh",
                    width: "15vw",
                    paddingLeft: "0.1vw",
                  }}
                  onChange={(e) => setnewPassword(e.target.value)}
                />
                {ispasschange ? (
                  <Change onClick={() => setispasschange(false)}>Change</Change>
                ) : (
                  <div>
                    {" "}
                    <h5 style={{ margin: "1%", marginLeft: "5vw" }}>
                      <b>Old Password</b>
                    </h5>
                    <input
                      type="password"
                      onChange={(e) => setcurrentPassword(e.target.value)}
                      style={{
                        marginLeft: "1.3vw",
                        marginTop: "0.5vh",
                        width: "15vw",
                        paddingLeft: "0.1vw",
                      }}
                    />
                    <Change onClick={changePassword}>Save</Change>
                  </div>
                )}
              </div>
            </div> */}
          < hr />
          <p style={{ color: "#3e6ae1" }} onClick={handleOpenDeactivate}>
            I wish to deactivate my account
          </p>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openDeactivate}
            onClose={handleCloseDeactivate}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openDeactivate}>
              <div className={classes.paper}>
                <h5 id="spring-modal-title">Are you sure you want to deactivate your account?</h5>
                <div className={classes.root} style={{ justifyContent: "space-evenly", marginTop: "20px" }}>
                  <ColorButton variant="contained" style={{ background: "#5db0d8" }}
                    onClick={() => { deleteUser() }}
                  >
                    Yes
                  </ColorButton>
                  <ColorButton variant="contained" color="secondary" onClick={handleCloseDeactivate}>No</ColorButton>
                </div>
              </div>
            </Fade>
          </Modal>

        </main >
      </div >
    </>
  );
};

const Change = styled.p`
  // margin-left: 7vw;
  // text-align: right;
  margin-top: 7px;
  margin-bottom: 0px;
  color: #3e6ae1;
`;

const P = styled.p`
  font-weight: 500;
  font-size: 20px;
  padding-left: 2vw;
  margin-top: 7vh;
  &:hover {
    cursor: pointer;
  }
  padding-top: 1.5vh;
  padding-bottom: 1.5vh;
`;

export default SettingAcc;
